import _ from 'lodash';
import { FlightFilterType } from '../constants';

const formatFlightFilters = (filterValues, defaultValues, flightfilterType) => {
  const request = {};
  if (!filterValues || _.isEmpty(filterValues)) return request;
  const key =
    flightfilterType === FlightFilterType.filterTakeOff ? 'filterTakeoff' : 'filterLanding';
  _.forEach(_.keys(filterValues), (k) => {
    if (
      !defaultValues ||
      !defaultValues[k] ||
      !defaultValues[k].min ||
      defaultValues[k].min !== filterValues[k].start
    ) {
      request[`${key}[${k}].start`] = filterValues[k].start;
    }
    if (
      !defaultValues ||
      !defaultValues[k] ||
      !defaultValues[k].max ||
      defaultValues[k].max !== filterValues[k].end
    ) {
      request[`${key}[${k}].end`] = filterValues[k].end;
    }
  });
  return request;
};

export default formatFlightFilters;
